"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC165 = void 0;
const abi_1 = require("./abi");
const bitwise_1 = require("./bitwise");
const supportsInterface = new abi_1.abi.Function({
    inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
});
exports.ERC165 = {
    supportsInterface,
    interfaceID: (0, bitwise_1.XORBatch)(supportsInterface.signature),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJjMTY1LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2VyYzE2NS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwrQkFBNEI7QUFDNUIsdUNBQXFDO0FBRXJDLE1BQU0saUJBQWlCLEdBQUcsSUFBSSxTQUFHLENBQUMsUUFBUSxDQUFDO0lBQ3pDLE1BQU0sRUFBRSxDQUFDLEVBQUUsWUFBWSxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsYUFBYSxFQUFFLElBQUksRUFBRSxRQUFRLEVBQUUsQ0FBQztJQUN6RSxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLE9BQU8sRUFBRSxDQUFDLEVBQUUsWUFBWSxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsRUFBRSxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQztJQUMzRCxlQUFlLEVBQUUsTUFBTTtJQUN2QixJQUFJLEVBQUUsVUFBVTtDQUNqQixDQUFDLENBQUM7QUFFVSxRQUFBLE1BQU0sR0FBRztJQUNwQixpQkFBaUI7SUFDakIsV0FBVyxFQUFFLElBQUEsa0JBQVEsRUFBQyxpQkFBaUIsQ0FBQyxTQUFTLENBQUM7Q0FDbkQsQ0FBQyJ9